
import Toast from 'vux/src/components/toast/index.vue'

import Cpts020 from '@/components/lyx-components/cpts020/index.vue'

import bus from '@/javascript/bus'

export default {
components:{
Toast,
Cpts020
},
data(){
return{
minHeight:0,
touristList:[],
activeList:[],
newActiveList:[],
show:false,
historyData:[],
cityEmpty: '出游意向不能为空',
params: JSON.parse(sessionStorage.getItem('historyData')),
showbtn: false,
oldTags: {}
}
},
mounted() {
this.minHeight = document.documentElement.clientHeight
document.title = '出游意向'
if(JSON.stringify(this.params) !== '{}' && this.params.travelId){
this.newActiveList = this.params.tags
this.oldTags = this.params.tags
this.showbtn = true
}else if(this.params.tags){
this.oldTags = this.params.tags
this.newActiveList = this.params.tags
}
this.typeList()
},
methods: {
typeList(){
this.$http.get('api/wtcp-recommend/public/travel/travelerIntent').then((response) => {
this.$set(this, 'touristList', response.data.data ? response.data.data : [])
}).then( () => {
this.touristList.map((item,index) => {
for(let i=0; i<this.newActiveList.length; i++){
if(item.id == this.newActiveList[i]){
this.$refs['span_'+index][0].setAttribute('class','active')
this.activeList.push(item)
}
}
})
})
},
ClickActive(item,index){
let a = this.$refs['span_'+index][0]

if(a.className=='noclass'){
a.className='active'
this.activeList.push(item)
}else{
a.className='noclass'
for(var i=0;i<this.activeList.length;i++){
if(item.id==this.activeList[i].id){
this.activeList.splice(i,1)
}
}
}
},
nextStep(){
this.newActiveList=[]
for(var i=0;i<this.activeList.length;i++){
var j=this.activeList[i].id;
this.newActiveList.push(j)

}
if(this.newActiveList.length>0){
this.params['tags'] = this.newActiveList.sort()

if(this.oldTags.toString() !== this.newActiveList.toString()){
this.params['changeTags'] = true
}
sessionStorage.setItem('historyData', JSON.stringify(this.params))
if(!this.params.transportType){
this.$router.push({path: '/travel-days'})
}else{
this.$router.push({path: '/choose-spot'})
}
}else{
this.show=true
}
},
creatTrip: function(){
this.newActiveList=[]
for(var i=0;i<this.activeList.length;i++){
var j=this.activeList[i].id;
this.newActiveList.push(j)
}
this.params['tags'] = this.newActiveList
sessionStorage.setItem('historyData', JSON.stringify(this.params))
this.$router.push({path: '/data-compute'})
if(this.params.createId && this.params.createId !== bus.userInfo.user.id){
this.$http.get("api/wtcp-recommend/public/travelPlan/app/reference?id=" + this.params.travelId[0].nowId + "&userId=" + bus.userInfo.user.id + '&deptCode=' + this.DEPT_CODE.DEPTCODE).then((response) => {

})
}
}
}
}
